import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    confirmed: {
      color: theme.palette.success.main,
      fontSize: theme.typography.pxToRem(11),
    },

    unconfirmed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(11),
    },

    updateButton: {
      textTransform: 'inherit',
      textAlign: 'right',
      padding: 0,
    },

    capitalize: {
      textTransform: 'capitalize',
    },

    textRight: {
      textAlign: 'right',
    },

    fullWidth: {
      background: 'red',
    },

    name: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.text.primary,
    },

    collapsiblePanel: {
      boxShadow: 'none',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderBottom: 'none',
      margin: '16px 0px',

      '&.Mui-expanded': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
      },
    },

    collapsibleHeaderBorder: {
      borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 24px;',
    },

    skuList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      paddingTop: 0,
      marginTop: -5,
      alignItems: 'flex-start',
    },

    skuListItem: {
      width: '100%',
      padding: '0 4px 8px 0',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      },
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: '13px',
      fontWeight: 500,
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

export { useStyles, listTextStyles, customCardStyles };
